import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/login-register.css";
import "./styles/media_queries.css";
import "./styles/filters_page.css";
import "./styles/index.css";
import DishesProvider from "./context/dishes";
import CartProvider from "./context/cart";
import ExtraStuffProvider from "./context/ExtraFunctions";
import CartServerSideProvider from "./context/api_response";
import UserProvider from "./context/user";
import { StripeProvider } from "react-stripe-elements";

ReactDOM.render(
  <StripeProvider apiKey="pk_test_51H4XZSKcPqaDnNoQ8wEEYcg7yH1lkCZsE0T2NtA7kn5qqnFmVaoamWMjse6VlMyr5dtjI8UqMWzRjOQQGSXvWQJ700BIbvklNC">
    <UserProvider>
      <CartServerSideProvider>
        <DishesProvider>
          <ExtraStuffProvider>
            <CartProvider>
              <App />
            </CartProvider>
          </ExtraStuffProvider>
        </DishesProvider>
      </CartServerSideProvider>
    </UserProvider>
  </StripeProvider>,

  document.getElementById("root")
);
